import React from 'react';
import { Phone, MessageCircle, MapPin } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 bg-slate-50 relative overflow-hidden" data-id="element-9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-11">
          <div data-id="element-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight mb-6" data-id="element-13">
              Потрібна правова допомога?
            </h2>
            <p className="text-lg text-slate-500 mb-10 max-w-md" data-id="element-14">
              Зв'яжіться з нами зручним для вас способом для отримання первинної
              консультації.
            </p>

            <div className="space-y-8" data-id="element-15">
              <div className="flex items-start gap-4" data-id="element-16">
                <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center shrink-0 border border-slate-100 shadow-sm" data-id="element-17">
                  <Phone className="text-slate-700" size={24} data-id="element-18" />
                </div>
                <div data-id="element-19">
                  <p className="text-sm text-slate-500 mb-1" data-id="element-20">Телефонуйте нам</p>
                  <a href="tel:+380634259030" className="text-2xl font-bold text-slate-900 hover:text-slate-600 transition-colors" data-id="element-21">
                    +38 063 425 90 30
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-22">
                <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center shrink-0 border border-slate-100 shadow-sm" data-id="element-23">
                  <MapPin className="text-slate-700" size={24} data-id="element-24" />
                </div>
                <div data-id="element-25">
                  <p className="text-sm text-slate-500 mb-1" data-id="element-26">
                    Географія роботи
                  </p>
                  <p className="text-slate-900 font-medium" data-id="element-27">
                    Працюємо онлайн та офлайн по всій Україні.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-3xl p-8 md:p-10 text-slate-900 shadow-premium border border-slate-100" data-id="element-28">
            <h3 className="text-2xl font-bold mb-2" data-id="element-29">Написати в месенджер</h3>
            <p className="text-slate-500 mb-8" data-id="element-30">
              Відповідаємо максимально швидко.
            </p>

            <div className="space-y-4" data-id="element-31">
              <a href="#" className="flex items-center justify-center gap-3 w-full bg-white border border-slate-200 hover:border-slate-300 hover:bg-slate-50 text-slate-700 py-4 rounded-2xl font-semibold transition-all" data-id="element-32">
                <MessageCircle size={20} data-id="element-33" />
                Написати в Telegram
              </a>
              <a href="#" className="flex items-center justify-center gap-3 w-full bg-white border border-slate-200 hover:border-slate-300 hover:bg-slate-50 text-slate-700 py-4 rounded-2xl font-semibold transition-all" data-id="element-34">
                <MessageCircle size={20} data-id="element-35" />
                Написати у Viber
              </a>
              <a href="#" className="flex items-center justify-center gap-3 w-full bg-white border border-slate-200 hover:border-slate-300 hover:bg-slate-50 text-slate-700 py-4 rounded-2xl font-semibold transition-all" data-id="element-36">
                <MessageCircle size={20} data-id="element-37" />
                Написати у WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}